module.exports = __webpack_public_path__ + "img/montage-logo.d9dd9fb5.png";